export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "process_line_exec_input": {
            "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cantidad de entrada"])},
            "unit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unidad"])},
            "process_line_product": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Producto de entrada"])},
            "input_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código"])},
            "process_line_exec_output": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Producto del paso anterior"])}
          }
        }
      }
    }
  })
}